export default __webpack_public_path__ + "static/media/HazSim.22be9ded.svg";